export const queryCategories = [
  { key: 'deals', label: '已成交', status: 6 },
  { key: 'canceled', label: '已撤单', status: 4 },
  { key: 'funds', label: '合约资金明细' },
  { key: 'failed', label: '委托失败', status: 2 }
]

export function contractQueryRequest(market, contractId, contractStatus, kind, page = 1) {
  const category = queryCategories.find(item => item.key === kind)
  if (!category || !['cn', 'hk', 'us'].includes(market) || !(Number(contractId) > 0)) throw new Error('请选择有效合约')
  const cn = market === 'cn', funds = kind === 'funds'
  const action = cn ? ({ deals: 'deal', canceled: 'cancel', failed: 'buySellFail', funds: Number(contractStatus) === 1 ? 'historyDetails' : 'details' })[kind] : funds ? 'contractRecord' : 'orderList'
  const params = {
    ...(cn ? { consult_id: contractId } : { contract_id: contractId, status: funds ? contractStatus : category.status }), page, page_size: 30
  }
  const post = action === 'historyDetails'
  return { url: `vexe/v1/${cn ? 'consult' : funds ? 'contract' : 'contract_order'}/${action}`, method: post ? 'post' : 'get', ...(post ? { data: params } : { params }) }
}

export function contractQueryPage(result, page) {
  const rows = Array.isArray(result) ? result : result && (result.data || result.list || result.lists)
  if (!Array.isArray(rows)) throw new Error('查询返回格式异常')
  const more = Array.isArray(result) || result.list ? false : result.last_page != null ? page < Number(result.last_page) : result.total_page != null ? page < Number(result.total_page) : result.total != null ? page * 30 < Number(result.total) : rows.length === 30
  return { rows, more }
}
